import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {ImportTemplateSubtype} from "@app/solution-manager/data-import/data-import";
import * as XLSX from "xlsx";
import {WorkSheet} from "xlsx";
import {plainToClass} from "class-transformer";
import {
  CommonTransformationService,
  DateService,
  FileService,
  Format,
  GrowlType,
  InvoiceSummary,
  PrimeNgConfig,
  PrimeNgSupportService,
  RegExp12DigitInteger2DigitFraction,
  Roles,
  RouteLink,
  TableColumn,
  TableFormat,
  TradingPartner,
  TradingPartnerService,
  TradingPartnerType,
  Transaction,
  Validation,
  YearRange
} from "@app/shared";
import {ConfirmationService, SelectItem} from "primeng/api";
import {LegacyInvoiceService} from "@app/shared/legacy-invoice/legacy-invoice.service";
import {GrowlService, UserService} from "@app/core";

@Component({
  selector: 'app-legacy-invoice',
  templateUrl: './legacy-invoice.component.html',
  styleUrls: ['./legacy-invoice.component.css']
})
export class LegacyInvoiceComponent implements OnInit,AfterViewInit {

  PrimeNgConfig = PrimeNgConfig;
  RouteLink: typeof RouteLink = RouteLink;
  TxnType: typeof Transaction = Transaction;
  Validation: typeof Validation = Validation;
  Transaction: typeof Transaction = Transaction;
  Format: typeof Format = Format;
  Roles: typeof Roles = Roles;
  RegExp12DigitInteger2DigitFraction = RegExp12DigitInteger2DigitFraction;
  yearRange = YearRange;

  @Input() transaction: Transaction;
  selectedTradingPartnerType: TradingPartnerType;

  displayLegacyInvoiceDialog: boolean = false;

  tableColumns: TableColumn[];
  existingInvoices: InvoiceSummary[];

  partners: TradingPartner[] = [];
  partnersDropDown: SelectItem[] = [];

  selectedInvoiceToEdit: InvoiceSummary;

  @Output() payInvoiceEvent = new EventEmitter<InvoiceSummary>();

  displayEditInvoiceDialog: boolean = false;

  @ViewChild('actionTemplate') actionTemplate: TemplateRef<any>;

  constructor(private tradingPartnerService: TradingPartnerService, private dataService: LegacyInvoiceService,
              private primeNgService: PrimeNgSupportService,  private fileService: FileService, private dateService: DateService,
              private transformationService: CommonTransformationService, private confirmationService: ConfirmationService,
              private growl: GrowlService, public userService: UserService) { }

  ngAfterViewInit(): void {
    this.buildTableColumns();
  }


  ngOnInit(): void {
    if(this.transaction == Transaction.VendorInvoice){
      this.selectedTradingPartnerType = TradingPartnerType.Vendor;
    } else {
      this.selectedTradingPartnerType = TradingPartnerType.Customer;
    }
    this.getExistingLegacyInvoices();
    this.buildDropDowns();
  }

  buildTableColumns() {
    this.tableColumns = [
      // invoiceDate	vendorInvoiceNumber	businessName	dueDate	invoiceAmountDue	balanceDue
      {field: 'invoiceDate', header: 'Invoice Date', format: TableFormat.Date},
      {field: 'referenceNumber', header: 'Invoice Reference Number'},
      {field: 'invoiceNumber', header: 'Invoice Number'},
      {field: 'businessName', header: 'Vendor/Customer'},
      {field: 'dueDate', header: 'Due Date', format: TableFormat.Date},
      {field: 'invoiceAmountDue', header: 'Amount Due', format: TableFormat.Currency},
      {field: 'originalBalanceAmount', header: 'Original Balance Due', format: TableFormat.Currency},
      {field: 'balanceDue', header: 'Current Balance Due', format: TableFormat.Currency},
      {field: 'action', header: 'Action', template: this.actionTemplate}
    ];
    this.tableColumns = [...this.tableColumns];
  }

  onClickManageInvoiceDialog() {
    this.displayLegacyInvoiceDialog = true;
    this.buildTableColumns();
  }

  buildDropDowns() {
    this.tradingPartnerService.getPartners(this.selectedTradingPartnerType).subscribe(res => {
      this.partners = plainToClass(TradingPartner, res?.list);
      this.partners.map(p => {
        this.partnersDropDown = this.transformationService.convertToDropDown("businessName", res.list, "id", true);
      });
    })
  }


  getExistingLegacyInvoices() {
    this.dataService.getExistingInvoices(this.transaction).subscribe(res => {
      this.existingInvoices = res;
    });
  }

  onClickAddNewInvoice() {
    this.selectedInvoiceToEdit = new InvoiceSummary();
    this.displayEditInvoiceDialog = true;
  }

  onClickShowPayment(invoiceSummary: InvoiceSummary) {
    this.payInvoiceEvent.emit(invoiceSummary);
  }

  onClickSaveInvoice() {

    this.selectedInvoiceToEdit.transaction = this.transaction;

    this.dataService.saveOrUpdateInvoice(this.selectedInvoiceToEdit).subscribe(res => {
      this.growl.add(GrowlType.Success, "Invoice Saved successfully");
      this.getExistingLegacyInvoices();
      this.displayEditInvoiceDialog = false;
    });


  }
  onClickDownloadExcelTemplate(): void {
    this.fileService.getImportTemplateThenSave(ImportTemplateSubtype.InvoiceTemplate);
  }


  onSelectConvertToInvoices(worksheet: WorkSheet): void {
    // this.journalEntryHasError = false;
    let invoicesToBeImported: InvoiceSummary[] = [];
    let legacyInvoices = plainToClass(InvoiceSummary, XLSX.utils.sheet_to_json(worksheet, {raw: true, dateNF: "YYYY-MM-DD"}));
    for (let invoice of legacyInvoices) {
      invoice.vendorOrCustomerId = this.partners.find(p => invoice.businessName === p?.businessName)?.id;
      if(!invoice.vendorOrCustomerId){
        continue;
      }
      invoice.transaction = this.transaction;
      invoicesToBeImported.push(invoice);

    }

    if(invoicesToBeImported?.length >=1){
      this.confirmationService.confirm({
        message: `Are you sure you want to import ${invoicesToBeImported?.length} invoices?` ,
        header: 'Import Legacy Invoices',
        key: 'legacyInvoice',
        icon: 'fa fa-warning',
        accept: () => {
          this.dataService.importInvoices(invoicesToBeImported).subscribe(res => {
            this.getExistingLegacyInvoices();
            this.growl.add(GrowlType.Success, "Invoices imported successfully");
            this.displayEditInvoiceDialog = false;
          });
        },
        reject: () => {
          this.growl.add(GrowlType.Info, "Excel import cancelled");
        }
      });
    }

    // this.journalAccountTotal = this.debitCreditFooterCalculation(this.journalEntry);


  }



}
